import {
    loginWithDiscord,
    loginWithGitHub,
    loginWithGoogle,
} from '@/lib/auth/session';
import { OAuthProviderIcon } from '@/components/auth/OAuthProviderIcon';
import { useAuth } from '@/context/AuthContext';

interface SocialLoginProps {
    onMockLogin?: (provider: string) => void;
}

export default function SocialLogin({ onMockLogin }: SocialLoginProps) {
    const { isMockMode, signInMock } = useAuth();

    const handleLogin = (provider: string) => {
        if (isMockMode) {
            signInMock();
            return;
        }

        if (onMockLogin) {
            onMockLogin(provider);
            return;
        }

        if (provider === 'github') loginWithGitHub();
        if (provider === 'google') loginWithGoogle();
        if (provider === 'discord') loginWithDiscord();
    };

    return (
        <div className="w-full max-w-md mx-auto">
            <div className="mb-6 text-center">
                <p className="mb-3 text-sm font-mono uppercase tracking-[0.35em] text-game-primary-l">
                    Initialize Identity
                </p>
                <p className="text-game-muted">Authenticate through a trusted provider.</p>
            </div>

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                <button
                    aria-label="Sign in with GitHub"
                    onClick={() => handleLogin('github')}
                    className="relative flex w-full items-center justify-center rounded-xl border border-white/10 bg-[#24292e] py-4 text-sm font-bold text-white shadow-xl transition-all active:scale-[0.98] hover:bg-[#2f363d]"
                >
                    <span className="pointer-events-none absolute left-5 top-1/2 -translate-y-1/2">
                        <OAuthProviderIcon provider="github" className="h-5 w-5 text-white" />
                    </span>
                    <span>Sign in with GitHub</span>
                </button>

                <button
                    aria-label="Sign in with Google"
                    onClick={() => handleLogin('google')}
                    className="relative flex w-full items-center justify-center rounded-xl bg-white py-4 text-sm font-bold text-gray-900 shadow-xl transition-all active:scale-[0.98] hover:bg-gray-100"
                >
                    <span className="pointer-events-none absolute left-5 top-1/2 -translate-y-1/2">
                        <OAuthProviderIcon provider="google" className="h-5 w-5" />
                    </span>
                    <span>Sign in with Google</span>
                </button>

                <button
                    aria-label="Sign in with Discord"
                    onClick={() => handleLogin('discord')}
                    className="relative flex w-full items-center justify-center rounded-xl border border-white/10 bg-[#5865F2] py-4 text-sm font-bold text-white shadow-xl transition-all active:scale-[0.98] hover:bg-[#4752c4]"
                >
                    <span className="pointer-events-none absolute left-5 top-1/2 -translate-y-1/2">
                        <OAuthProviderIcon provider="discord" className="h-5 w-5 text-white" />
                    </span>
                    <span>Sign in with Discord</span>
                </button>
            </div>

            <div className="mt-4 rounded-xl border border-game-primary/10 bg-game-surface-3 p-4 text-center">
                <p className="text-[0.65rem] font-mono lowercase text-game-dim">
                    OAuth only. We only store your provider ID. zero PII.
                </p>
            </div>
        </div>
    );
}
